<template>
  <v-row>
    <v-col cols="3">
      <v-btn
        fab small color="blue" class="white--text" :outlined="localGender !== 'm'"
        @click="selectGender('m')">
        m
      </v-btn>
    </v-col>
    <v-col cols="3">
      <v-btn
        fab small color="red" class="white--text" :outlined="localGender !== 'f'"
        @click="selectGender('f')">
        f
      </v-btn>
    </v-col>
    <v-col cols="3">
      <v-btn
        fab small color="green" class="white--text" :outlined="localGender !== 'n'"
        @click="selectGender('n')">
        n
      </v-btn>
    </v-col>
    <v-col cols="3">
      <v-btn
        fab small color="orange" class="white--text" :outlined="localGender !== 'pl'"
        @click="selectGender('pl')">
        pl
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'GenderChooser',
  props: {
    gender: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    localGender: '',
  }),
  methods: {
    selectGender(localGender) {
      this.localGender = this.localGender !== localGender ? localGender : '';
      this.$emit('select:gender', this.localGender);
    },
  },
  created() {
    this.localGender = this.gender;
  },
  watch: {
    gender() {
      this.localGender = this.gender;
    },
  },
};
</script>
